import styled from 'styled-components'

const Component = styled.div`
  text-align: center;
`

const Image = styled.img`
  width: 80%;
  margin-top: 50px;

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    width: 100%;
  }
`

const ImageComponent = () => (
  <Component>
    <Image src={'/static/images/citifyd_app.png'} alt="Citifyd App" />
  </Component>
)

export default ImageComponent
